import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  Box,
  Radio,
  IconButton,
  Checkbox,
  Grid,
  FormHelperText,
} from "@mui/material";
import { Close, ExpandMore } from "@mui/icons-material";
import DialogWrapper from "./DialogWrapper";
import { useForm } from "react-hook-form";
import StyledTextField from "./elements/StyledTextField";
import { getAllCountries } from "../services/api/country.api";
import { toast } from "react-toastify";
import { createGroup, getAllOperators, getAllUserGroupPermissions, getAllUsers, updateUserGroup } from "../services/api/users.api";
import { MdLibraryAdd } from "react-icons/md";
import StyledButton from "./elements/StyledButton";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import styled from "styled-components";
import StyledTable from "../components/StyledTable";
import StyledSwitchField from "./elements/StyledSwitchField";
import { userGroupUserHeadCells } from "../constants/Data";
import { BiWindowAlt } from "react-icons/bi";
import { IoEarth } from "react-icons/io5";
import TypeSelect from "./elements/TypeSelect";
import { StyledSwitch } from "./styled/StyledSwitch.styled";
import { fetchYearAndQuarterByCountry } from "../services/api/mapLocation.api";
import StyledSelect from "./elements/StyledSelect";
import MultiSelectChip from "./elements/MultiSelectChip";
import { getDashboards } from "../services/api/dashboard.api";


const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMore sx={{ fontSize: '1.5rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, .03)',
  height: '35px',
  minHeight: '35px',
  padding: '0 8px',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles('dark', {
    backgroundColor: 'rgba(255, 255, 255, .05)',
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '0px',
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const InnerAccordionHeader = styled.div`
  flex: 1;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const StyledIconButton = styled(IconButton)`
  color: #CD1F1F;
  padding: 0px;
`;

const StyledSelectAll = styled(IconButton)`
  color: #006F35;
  font-size: 14px;
`;

const AccordianWrapper = styled.div`
  padding-left: 10px;
`;

const ButtonWrapper = styled.div`
  width: 30%;
  padding-bottom: 20px;
  padding-top: 10px;
`;

const InputWrapper = styled.div`
  margin-left: 10px;
`;

const CountryWrapper = styled.div`
  padding-top: 15px;
  padding-left: 10px;
  padding-bottom: 15px;
`;

const PermissionsWrapper = styled.div`
  padding-left: 20px;
  font-style: italic;
  font-size: 12px;
  color: #707070;
  fontFamily: '"Open Sans", sans-serif',
`;

const TextWrapper = styled.div`
  margin-left: 16px; 
  margin-top: 5px;
  font-weight: bold;
  color: #707070;
`;

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontSize: "12px",
    fontFamily: '"Open Sans", sans-serif',
  },
}));

const StyledFormControlCheckBoxLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontSize: "16px",
    fontFamily: '"Open Sans", sans-serif',
    color: "#707070"
  },
}));

const ConfrimTextWrapper = styled.div`
  margin-left: 14px;
  font-family: 'Open Sans';
  font-size: 16px;
  color: #707070;
`;


const UserGroupModal = ({
  open,
  setOpen,
  userData,
  handleCreateNewUser,
  handleEditUser,
  edit,
  moduleOptions,
  pageRerender,
  getGroups,
  editCountries,
  selectedPermissions,
  selectedGroup,
  ...props
}) => {
  const {handleSubmit, register, watch, setValue, control, } = useForm({});
  const [countries, setCountries] = useState([]);
  const [users, setUsers] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedCountryPerm, setSelectedCountryPerm] = useState([]);
  const [viewCountries, setViewCountries] = useState(false);
  const [expandedStates, setExpandedStates] = useState({});
  const [operators, setOperators] = useState([]);
  const [name, setName] = useState("init");
  const [groupName, setGroupName] = useState("");
  const [groupId, setGroupId] = useState();
  const [allUsers, setAllUsers] = useState();
  const [errMsg, setErrMsg] = useState(null);
  const [errMsgName, setErrMsgName] = useState(null);
  const nameGroup = watch("name");
  const web_map_access = watch("web_map_access");
  const [openConfirmation, setOpenConfirmation] =useState(false);
  const [editReuest, setEditRequest] =useState({});
  const [email, setEmail] = useState("");
  const [quarter, setQuarter] = useState([]);
  const [dataPermissions, setDataPermissions] = useState([]);
  const [perms, setPerms] = useState([]);
  const [perm, setPerm] = useState("init");
  const dashboardPerm = watch("dashboard_access");
  const add_dashboard = watch("add_dashboard");
  const manage_dashboard = watch("manage_dashboard");
  const web_portal_access = watch("web_portal_access");

  // Fetch countries, users, and permissions from APIs
  useEffect(() => {
    const fetchPermissions = async () => {
      try{
        let response = await getAllUserGroupPermissions();
        setPermissions(response);
      }catch(err){
        console.log(err);
        toast.error(err.message, { theme: "colored" });
      }
    };

    const fetchAllOperators = async () => {
      try{
        let response = await getAllOperators();
        setOperators(response);
      }catch(err){
        console.log(err);
        toast.error(err.message, { theme: "colored" });
      }
    };

    fetchCountries();
    fetchUsers();
    fetchPermissions();
    fetchAllOperators();
    fetchDashboardPermissions();
  }, []);

  useEffect(() => {
    if (!dashboardPerm)  {
      setValue("data_perms", []);
      setValue("manage_dashboard", false);
      setValue("add_dashboard", false);
    }
  }, [dashboardPerm])

  useEffect(() => {
    if (!web_map_access)  {
      setSelectedCountryPerm([]);
      setSelectedCountries([]);
    }
  }, [web_map_access])

  useEffect(() => {
    if (web_map_access || web_portal_access)  {
      setErrMsg(null)
    }
  }, [web_map_access, web_portal_access])
  
  useEffect(() => {
    if (edit) {
      const groupID = selectedGroup?._id;
      const groupName = selectedGroup?.group_name;
      const filteredCountries = countries.filter(c => !editCountries.includes(c.code));
      const country = countries.filter(obj => editCountries.includes(obj.code));
      const users =  selectedGroup?.users;
      const usersToSelect = allUsers?.filter((user) => !users?.some((selectedUser) => selectedUser?.user_id === user._id))
        .map(({ _id, name, email }) => ({
        user_id: _id,
        name,
        email,
      }));
      setValue("name", groupName);
      setValue("web_map_access", selectedGroup?.web_map_access);
      setValue("dashboard_access", selectedGroup?.dashboard_access);
      setValue("web_portal_access", selectedGroup?.web_portal_access);
      setUsers(usersToSelect);
      setSelectedCountries(country);
      setCountries(filteredCountries);
      setSelectedCountryPerm(selectedPermissions);
      setGroupId(groupID);
      setGroupName(groupName);
      setSelectedUsers(users ? users : []);
      setPerms(selectedGroup?.data_permissions || []);
      setValue("add_dashboard", selectedGroup?.add_dashboard);
      setValue("manage_dashboard", selectedGroup?.manage_dashboard);
    }
  },[editCountries, selectedGroup, selectedPermissions])

  //fetch year and quarter
  const fetchYearQuarter = async (code) => {
    try {
      const { data } = await fetchYearAndQuarterByCountry(code);
      if (!quarter.some((q) => q.countryCode === code)) {
        setQuarter((prevQuarter) => [
          ...prevQuarter,
          { countryCode: code, data },
        ]);
      }
      const selectedYears = selectedCountryPerm.find((perm) => perm.country === code)?.years
      if (!selectedYears) {
        setSelectedCountryPerm((prevState) => {
          return prevState.map((perm) =>
            perm.country === code
              ? { ...perm, years: {}}
              : perm
          );
        });
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, { theme: "colored" });
    }
  }

  const fetchDashboardPermissions = async()=>{
    try{
      let response = await getDashboards();
      setDataPermissions(response.data?.map((data) => data.name));
    }catch(err){
      console.log(err);
      toast.error(err.message, { theme: "colored" });
    }
  };

  //fetch countries
  const fetchCountries = async()=>{
    try{
      let response = await getAllCountries();
      setCountries(response);
    }catch(err){
      console.log(err);
      toast.error(err.message, { theme: "colored" });
    }
  };

  //fetch users
  const fetchUsers = async () => {
    try{
      let response = await getAllUsers(
        1,
        "name",
        "asc",
        "all users",
        20000
      );
      setUsers(
        response.docs
          .map(({ _id, name, email }) => ({
            user_id: _id,
            name,
            email,
          }))
      )
      setAllUsers(response.docs); 
    }catch(err){
      console.log(err);
      toast.error(err.message, { theme: "colored" });
    }
  };

  //add user group
  const createUserGroup = async (group) => {
    try{
      let response = await createGroup(group);
      if (response.successMessage) {
        toast.success(response.successMessage, { theme: "colored" });
        setTimeout(() => {
          getGroups();
          cancelAction();
        }, 100);
      }
    }catch(err){
      const errorMessage = err.response?.data?.error?.message || "Something went wrong!";
      console.log(errorMessage);
      toast.error(errorMessage, { theme: "colored" });
    }
  };

  // edit user group
  const editUserGroup = async (group) => {
    try{
      let response = await updateUserGroup(groupId, group);
      if (response.successMessage) {
        toast.success(response.successMessage, { theme: "colored" });
        setTimeout(() => {
          getGroups();
          cancelAction();
        }, 100);
      }
      setOpenConfirmation(false);
    }catch(err){
      const errorMessage = err.response?.data?.error?.message || "Something went wrong!";
      console.log(errorMessage);
      toast.error(errorMessage, { theme: "colored" });
    }
  };

  //Select Country
  const onSelectCountry = (countryId) => {
    const selectedCountry = countries.find(country => country._id === countryId);
    setSelectedCountries([...selectedCountries, selectedCountry]);
    setSelectedCountryPerm(prevState => [
      ...prevState, 
      { country: selectedCountry.code, permissions: permissions }
    ]);
    setCountries(countries.filter(country => country._id !== countryId));
  };

  //get operators for selected country
  const getOperators = ({ code, perm, subPerm, subSubPerm, is_mno } = {}) => {
    const allOperators = operators?.find(op => op.countryCode === code)?.operators;
    const mnoOperators = is_mno ? 
      allOperators?.filter((op) => op.type === "MNO" && op.operatorCode !== "Others" && op.operatorCode !== "No Tenants")
      : allOperators?.filter((op) => op.type === "MNO");
    const nonMNOOperators = allOperators?.filter((op) => op.type === "Non-MNO");
    return (
      <div>
          {mnoOperators.length > 0 && !is_mno &&(
            <div>
              <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: "160px", borderBottom: "1px solid #EEEEEE", }}>
                <div style={{fontSize: "12px", fontFamily: '"Open Sans", sans-serif', height: "37px", display: "flex", alignItems: "center"}}>MNO</div>
              </Box> 
            </div>
          )}
          {mnoOperators.length > 0 && mnoOperators.map(op => {
            const checked = isOperatorSelected(code, op.operatorCode, perm, subPerm, subSubPerm);
            const disabled = checkDisableHelper(code, perm, subPerm, subSubPerm);
            const toggled = isOthersToggled(code, op.operatorCode, perm, subPerm, subSubPerm)
            return (
            <div>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: !is_mno ? "190px" : !subPerm ? "100px" : "130px", borderBottom: "1px solid #EEEEEE", }}>
              <StyledFormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) =>handleOperatorSelection(code, op.operatorCode, e.target.checked, perm, subPerm, subSubPerm)}
                    size="small"
                    disabled={!is_mno ? disabled : !subPerm ? checkDisableHelper(code, perm) :  checkDisableHelper(code, perm, subPerm)}
                  />
                }
                label={op.name}
                sx={{flex: 3}}
              />
              {!is_mno && op.operatorCode !== "Others" && (
                <div style={{flex: 5, display: "flex", flexDirection: "row", alignItems: "center"}}>
                  <div style={{fontSize: "12px", fontFamily: '"Open Sans", sans-serif', color : disabled || checked ? "#bababa" : "inherit"}}>Group under others</div>
                  <StyledSwitch 
                    checked={!disabled && toggled} 
                    disabled={disabled || checked}
                    onChange={(e) =>handleToggleOthers(code, op.operatorCode, e.target.checked, perm, subPerm, subSubPerm)}
                  />
                </div>
              )}
              </Box> 
          </div>
          )})}
          {!is_mno && (
            <>
              {nonMNOOperators.length > 0 && (
                <div>
                  <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: "160px", borderBottom: "1px solid #EEEEEE", }}>
                    <div style={{fontSize: "12px", fontFamily: '"Open Sans", sans-serif', height: "37px", display: "flex", alignItems: "center"}}>Non-MNO</div>
                  </Box> 
                </div>
              )}
              {nonMNOOperators.length > 0 && nonMNOOperators.map(op => {
                const checked = isOperatorSelected(code, op.operatorCode, perm, subPerm, subSubPerm);
                const disabled = checkDisableHelper(code, perm, subPerm, subSubPerm);
                const toggled = isOthersToggled(code, op.operatorCode, perm, subPerm, subSubPerm)

                return (
                  <div>
                    <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: "190px", borderBottom: "1px solid #EEEEEE" }}>
                    <StyledFormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={(e) =>handleOperatorSelection(code, op.operatorCode, e.target.checked, perm, subPerm, subSubPerm)}
                          size="small"
                          disabled={disabled}
                        />
                      }
                      label={op.name}
                      sx={{flex: 3}}
                    />
                      <div style={{flex: 5, display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div style={{fontSize: "12px", fontFamily: '"Open Sans", sans-serif', color : disabled || checked ? "#bababa" : "inherit"}}>Group under others</div>
                        <StyledSwitch 
                          checked={!disabled && toggled} 
                          disabled={disabled || checked}
                          onChange={(e) =>handleToggleOthers(code, op.operatorCode, e.target.checked, perm, subPerm, subSubPerm)}
                        />
                      </div>
                    </Box> 
                  </div>
                )
              })}
            </>
          )}
      </div>
    )
  }

  //Remove Country
  const onRemoveCountry = (countryId, countryName) => {
    const removedCountry = selectedCountries.find(country => country._id === countryId);
    setCountries([...countries, removedCountry]);
    setSelectedCountries(selectedCountries.filter(country => country._id !== countryId));
    setSelectedCountryPerm(selectedCountryPerm.filter(country => country.country !== countryName));
  };

  //Add permission
  const handleAddPermissions = (countryName, permName, checked, isOperators, isMNO) => {
    const allOperators = operators.find(op => op.countryCode === countryName)?.operators || [];
    const mnoOperators = allOperators.filter(op => op.type === "MNO" && op.operatorCode !== "Others" && op.operatorCode !== "No Tenants");
  
    setSelectedCountryPerm(prevState => {
      return prevState.map(country => {
        if (country.country === countryName) {
          // Check if the permission already exists
          const existingPermission = country.permissions.find(perm => perm.name === permName);
  
          if (existingPermission) {
            // Update the existing permission
            return {
              ...country,
              permissions: country.permissions.map(perm => {
                if (perm.name === permName) {
                  return {
                    ...perm,
                    is_enable: checked,
                    operators: isOperators && checked ? (isMNO ? mnoOperators : allOperators) : undefined,
                    is_operators: isOperators ?? false,
                  };
                }
                return perm;
              }),
            };
          } else {
            // Add the new permission
           const  newPermission = permissions.find((p) => p.name === permName);
            return {
              ...country,
              permissions: [
                ...country.permissions,
                {
                  name: newPermission.name,
                  is_enable: checked,
                  operators: isOperators && checked ? (isMNO ? mnoOperators : allOperators) : [],
                  is_operators: isOperators ?? false,
                  sub_permissions: newPermission.sub_permissions
                },
              ],
            };
          }
        }
        return country;
      });
    });
  };

  const handleAddSubPermissions = (countryName, permName, subPermName, checked, isOperators, isMNO) => {
    const allOperators = operators.find(op => op.countryCode === countryName).operators;
    const mnoOperators = allOperators?.filter((op) => op.type === "MNO" && op.operatorCode !== "Others" & op.operatorCode !== "No Tenants");
    setSelectedCountryPerm(prevState =>
      prevState.map(country => {
        if (country.country === countryName) {
          return {
            ...country,
            permissions: country.permissions.map(perm => {
              if (perm.name === permName) {
                return {
                  ...perm,
                  sub_permissions: perm.sub_permissions.map(subPerm => {
                    if (subPerm.name === subPermName) {
                      return {
                        ...subPerm,
                        is_enable: checked,
                        operators: isOperators && checked ? isMNO ? mnoOperators : allOperators : undefined,
                        is_operators: isOperators ?? false
                      };
                    }
                    return subPerm;
                  }),
                };
              }
              return perm;
            }),
          };
        }
        return country;
      })
    );
  };

  const handleAddNestedSubPermissions = (countryName, permName, subPermName, nestedSubPermName, checked, isOperators, isMNO) => {
    const allOperators = operators.find(op => op.countryCode === countryName).operators;
    const mnoOperators = allOperators?.filter((op) => op.type === "MNO");
    setSelectedCountryPerm(prevState =>
      prevState.map(country => {
        if (country.country === countryName) {
          return {
            ...country,
            permissions: country.permissions.map(perm => {
              if (perm.name === permName) {
                return {
                  ...perm,
                  sub_permissions: perm.sub_permissions.map(subPerm => {
                    if (subPerm.name === subPermName) {
                      return {
                        ...subPerm,
                        sub_permissions: subPerm.sub_permissions.map(nestedSubPerm => {
                          if (nestedSubPerm.name === nestedSubPermName) {
                            return {
                              ...nestedSubPerm,
                              is_enable: checked,
                              operators: isOperators && checked ? isMNO ? mnoOperators : allOperators : undefined,
                              is_operators: isOperators ?? false
                            };
                          }
                          return nestedSubPerm;
                        }),
                      };
                    }
                    return subPerm;
                  }),
                };
              }
              return perm;
            }),
          };
        }
        return country;
      })
    );
  };

  const isCheckedGeneric = (countryName, permName, ...subPermNames) => {
    const country = selectedCountryPerm.find((country) => country.country === countryName);
    if (!country) return false;
  
    let currentLevel = country.permissions.find((perm) => perm.name === permName);
    if (!currentLevel) return false;
  
    // Helper function to clear operators and disable permissions recursively
    const disableRecursively = (permission) => {
      permission.is_enable = false;
      permission.operators = [];
      if (permission.sub_permissions) {
        permission.sub_permissions.forEach((sub) => disableRecursively(sub));
      }
    };
  
    for (const subPermName of subPermNames) {
      if (!currentLevel.is_enable) {
        disableRecursively(currentLevel);
        return false;
      }
  
      if (!currentLevel.sub_permissions) return false;
      currentLevel = currentLevel.sub_permissions.find((sub) => sub.name === subPermName);
      if (!currentLevel) return false;
    }
    if (!currentLevel.is_enable) {
      disableRecursively(currentLevel);
      return false;
    }
  
    return currentLevel.is_enable;
  };
  
  const handleSelectAll = (countryName) => {
    setSelectedCountryPerm(prevState =>
      prevState.map(country => {
        if (country.country === countryName) {
          const selectedCountryOperators = 
            operators.find(op => op.countryCode === countryName)?.operators || [];
          const mnoOperators = selectedCountryOperators?.filter((op => op.type === "MNO" && op.operatorCode !== "Others" && op.operatorCode !== "No Tenants"));
          const areAllOperators = areAllOperatorsSelected (
            country.permissions,
          );

          const yearAndQuarters = quarter?.find((q) => q.countryCode === countryName)?.data;
          const allYearsandQuartersSelected = !country.years || Object.keys(country.years).length === 0;

          const checkAllPermissionsEnabled = (permissions) =>
            permissions.every(permission => 
              permission.is_enable &&
              (!permission.sub_permissions || checkAllPermissionsEnabled(permission.sub_permissions))
            );
  
          const allPermissionsEnabled = checkAllPermissionsEnabled(country.permissions);
  
          const allOperatorsAndPermissionsSelected =  allPermissionsEnabled && areAllOperators && allYearsandQuartersSelected;

          const selectAllOperators = (is_mno, is_operators, enable) => {
            if (is_operators) {
              if (is_mno) {
                return mnoOperators?.map(op => ({
                  ...op,
                  is_permitted:  enable,
                  is_others: false,
                }));
              } 
              if (!is_mno) {
                return selectedCountryOperators?.map(op => ({
                  ...op,
                  is_permitted: op.operatorCode === "Others" ? false : enable,
                  is_others: op.operatorCode === "Others" ? true : false,
                }))
              }
            }
            return [];
          };
          
  
          const togglePermissions = (permissions, enable) =>
            permissions.map((permission) => {
              return {
                ...permission,
                is_enable: enable,
                operators: selectAllOperators(permission?.is_mno, permission?.is_operators, enable),
                sub_permissions: permission.sub_permissions
                  ? togglePermissions(permission.sub_permissions, enable)
                  : [],
              };
            });
          return {
            ...country,
            permissions: togglePermissions(country.permissions, !allOperatorsAndPermissionsSelected),
            years: allOperatorsAndPermissionsSelected ? yearAndQuarters : {}
          };
        }
        return country;
      })
    );
  };
  
  const areAllOperatorsSelected = (permissions) => {
    const checkPermissions = (permissionsList) => {
      let isValid = true;
  
      for (const permission of permissionsList) {
  
        if (permission.is_enable) {
          if (permission.is_operators) {
            if (
              !permission.operators ||
              !permission.operators.every((operator) => (operator.operatorCode === "Others" ? operator.is_others : operator.is_permitted))
            ) {
              console.log("Invalid operator permission:", permission);
              isValid = false;
            }
          }
        }
        if (Array.isArray(permission.sub_permissions)) {
          const subPermissionResult = checkPermissions(permission.sub_permissions);
          if (!subPermissionResult) {
            isValid = false;
          }
        }
      }
  
      return isValid;
    };
    return checkPermissions(permissions);
  };
  
  const isChecked = (countryName, permName, subPermName) =>
    isCheckedGeneric(countryName, permName, subPermName);
  
  const isCheckedPerm = (countryName, permName) =>
    isCheckedGeneric(countryName, permName);
  
  const isCheckedSubPerm = (countryName, permName, subPermName, subSubPermName) =>
    isCheckedGeneric(countryName, permName, subPermName, subSubPermName);


  const checkDisableHelper = (countryName, permName, subPermName = null, subSubPermName = null) => {
    const country = selectedCountryPerm.find(country => country.country === countryName);
    if (!country) return false;

    const permission = country.permissions.find(perm => perm.name === permName);
    if (!permission) return false;

    if (subSubPermName) {
        const subSubPermission = permission.sub_permissions
            .find(sub => sub.name === subPermName)?.sub_permissions
            ?.find(sub => sub.name === subSubPermName);
        if (!subSubPermission) return false;
        return !subSubPermission.is_enable;
    }

    if (subPermName) {
        const subPermission = permission.sub_permissions.find(sub => sub.name === subPermName);
        if (!subPermission) return false;
        return !subPermission.is_enable;
    }

    return !permission.is_enable;
  };

  const checkDisable = (countryName, permName) => {
    return checkDisableHelper(countryName, permName);
  };

  const checkDisableSubPerm = (countryName, permName, subPermName) => {
    return checkDisableHelper(countryName, permName, subPermName);
  };

  const handleOperatorSelection = (label, operator, isChecked, perm, subPerm, subSubPerm) => {
    const selectedCountryOperators = 
            operators.find(op => op.countryCode === label)?.operators || [];
    setSelectedCountryPerm((prevState) => {
      const newState = prevState.map((country) => {
        if (country.country !== label) {
          return country;
        }
  
        return {
          ...country,
          permissions: country.permissions?.map((p) => {
            if (p.name !== perm) {
              return p;
            }
  
            // Function to update or add operator with "Others" handling
            const updateOrAddOperator = (operators) => {
              const operatorExists = operators.some((op) => op.operatorCode === operator);
  
              if (operatorExists) {
                return operators.map((op) =>
                  op.operatorCode === operator
                    ? {
                        ...op,
                        is_others: operator === "Others" ? isChecked : false,
                        is_permitted: operator === "Others" ? false : isChecked,
                      }
                    : op
                );
              }
  
              // Add new operator if not existing
              const newOperator = selectedCountryOperators?.find((op) => op.operatorCode === operator)
              const newOp = {
                operatorCode: newOperator.operatorCode,
                name: newOperator.name,
                type: newOperator.type,
                is_others: operator === "Others" ? !isChecked : false,
                is_permitted: operator === "Others" ? false : isChecked,
              }
              const newOperatorArray = [...operators, newOp]
              return newOperatorArray;
            };
  
            // Update operators at the top level if no subPerm or subSubPerm
            if (!subPerm) {
              return {
                ...p,
                operators: updateOrAddOperator(p.operators || []),
              };
            }
  
            // Handle sub-permissions
            return {
              ...p,
              sub_permissions: p.sub_permissions?.map((s) => {
                if (s.name !== subPerm) {
                  return s;
                }
  
                // Update operators at sub-permission level if no subSubPerm
                if (!subSubPerm) {
                  return {
                    ...s,
                    operators: updateOrAddOperator(s.operators || []),
                  };
                }
  
                // Handle sub-sub-permissions
                return {
                  ...s,
                  sub_permissions: s.sub_permissions?.map((ss) =>
                    ss.name === subSubPerm
                      ? {
                          ...ss,
                          operators: updateOrAddOperator(ss.operators || []),
                        }
                      : ss
                  ),
                };
              }),
            };
          }),
        };
      });
  
      return newState;
    });
  };  

  const handleToggleOthers = (label, operator, isChecked, perm, subPerm, subSubPerm) => {
    const selectedCountryOperators = operators.find(op => op.countryCode === label)?.operators || [];
    const addOrUpdateOperator = (operators = [], operatorCode, isChecked) => {
      const operatorIndex = operators.findIndex((op) => op.operatorCode === operatorCode);
  
      if (operatorIndex === -1) {
        const newOperator = selectedCountryOperators?.find((op) => op.operatorCode === operator)
        const newOp = {
          operatorCode: newOperator.operatorCode,
          name: newOperator.name,
          type: newOperator.type,
          is_others: isChecked,
          is_permitted: false,
        }
        const newOperatorArray = [...operators, newOp]
        return newOperatorArray;
      }
  
      // If operator exists, update it
      return operators.map((op) =>
          op.operatorCode === operatorCode
              ? {
                    ...op,
                    is_others: isChecked,
                    is_permitted: false,
                }
              : op
      );
    };
    setSelectedCountryPerm((prevState) => {
        const newState = prevState.map((country) => {
            if (country.country !== label) {
                return country;
            }

            return {
                ...country,
                permissions: country.permissions?.map((p) => {
                    if (p.name !== perm) {
                        return p;
                    }

                    // Update operators at the top level if no subPerm or subSubPerm
                    if (!subPerm) {
                        return {
                            ...p,
                            operators: isChecked
                                ? addOrUpdateOperator(p.operators, operator, true)
                                : addOrUpdateOperator(p.operators, operator, false),
                        };
                    }

                    // Handle sub-permissions
                    return {
                        ...p,
                        sub_permissions: p.sub_permissions?.map((s) => {
                            if (s.name !== subPerm) {
                                return s;
                            }

                            // Update operators at sub-permission level if no subSubPerm
                            if (!subSubPerm) {
                                return {
                                    ...s,
                                    operators: isChecked
                                        ? addOrUpdateOperator(s.operators, operator, true)
                                        : addOrUpdateOperator(s.operators, operator, false),
                                };
                            }

                            // Handle sub-sub-permissions
                            return {
                                ...s,
                                sub_permissions: s.sub_permissions?.map((ss) =>
                                    ss.name === subSubPerm
                                        ? {
                                              ...ss,
                                              operators: isChecked
                                                  ? addOrUpdateOperator(ss.operators, operator, true)
                                                  : addOrUpdateOperator(ss.operators, operator, false),
                                          }
                                        : ss
                                ),
                            };
                        }),
                    };
                }),
            };
        });

        return newState;
    });
};


  const isOperatorSelected = (label, operator, perm, subPerm, subSubPerm) => {
    const country = selectedCountryPerm.find((country) => country.country === label);
  
    if (!country) {
      return false;
    }
  
    // Check at the top-level permission
    if (perm && !subPerm && !subSubPerm) {
      const permission = country.permissions?.find((p) => p.name === perm);
      return permission?.operators?.find((op) => op.operatorCode === operator)?.is_permitted || false;
    }
  
    // Check at the sub-permission level
    if (perm && subPerm && !subSubPerm) {
      const permission = country.permissions?.find((p) => p.name === perm);
      if (!permission) {
        return false;
      }
      const subPermission = permission.sub_permissions?.find((s) => s.name === subPerm);
      return subPermission?.operators?.find((op) => op.operatorCode === operator)?.is_permitted || false;
    }
  
    // Check at the sub-sub-permission level
    if (perm && subPerm && subSubPerm) {
      const permission = country.permissions?.find((p) => p.name === perm);
      if (!permission) {
        return false; 
      }
      const subPermission = permission.sub_permissions?.find((s) => s.name === subPerm);
      if (!subPermission) {
        return false;
      }
      const subSubPermission = subPermission.sub_permissions?.find((ss) => ss.name === subSubPerm);
      const othersPermitted = subSubPermission?.operators?.find((op) => op.operatorCode === operator)?.is_others;
      return operator === "Others" ? othersPermitted || false : subSubPermission?.operators?.find((op) => op.operatorCode === operator)?.is_permitted || false;
    }
  
    return false;
  };

  const isOthersToggled = (label, operator, perm, subPerm, subSubPerm) => {
    const country = selectedCountryPerm.find((country) => country.country === label);
    const selectedCountryOperators = operators.find(op => op.countryCode === label)?.operators || [];
  
    if (!country) {
      return false;
    }
  
    // Check at the sub-sub-permission level
    if (perm && subPerm && subSubPerm) {
      const permission = country.permissions?.find((p) => p.name === perm);
      if (!permission) {
        return false; 
      }
      const subPermission = permission.sub_permissions?.find((s) => s.name === subPerm);
      if (!subPermission) {
        return false;
      }
      const subSubPermission = subPermission.sub_permissions?.find((ss) => ss.name === subSubPerm);
      if (!subSubPermission) {
        return false;
      }
  
      // Check if the operator exists in the operators array
      let operatorEntry = subSubPermission.operators?.find((op) => op.operatorCode === operator);
  
      if (!operatorEntry) {
        // If the operator does not exist, add it to the array
        const newOperator = selectedCountryOperators.find((op) => op.operatorCode === operator);
        if (newOperator) {
          subSubPermission.operators = subSubPermission.operators || [];
          subSubPermission.operators.push(newOperator);
          operatorEntry = newOperator;
        } else {
          return false;
        }
      }  
  
      return operatorEntry.is_others || false;
    }
  
    return false;
  };
  

  const handleUserSelection = (email) => {
    if (email) {
      const user = users.find(user => user.email === email);
      const newUser = {
        name: user.name,
        email: user.email,
        user_id: user.user_id,
      }
      
      setSelectedUsers((prevState) => {
          return [...prevState, newUser];
      });
      setUsers((prev) => {
        return prev.filter(item => item.email !== email);
      })
      setName("init");
      setEmail("");
      }
  };

  const handleRemoveUser = (user) => {
    setSelectedUsers((prev) => {
      return prev.filter(item => item.email !== user.email);
    });
    setUsers((prevState) => {
      return [...prevState, user];
  });
  }
  
  const cancelAction = () => {
    fetchCountries();
    fetchUsers();
    setOpen(false);
    setSelectedCountryPerm([]);
    setSelectedCountries([]);
    setSelectedUsers([]);
    setValue("name", null);
    setGroupName();
    setGroupId();
    setExpandedStates({});
    setValue("web_portal_access", false);
    setValue("web_map_access", false);
    setErrMsg(null);
    setErrMsgName(null);
    setEditRequest();
    setEmail("");
    getGroups();
    setViewCountries(false);
    setValue("dashboard_access", false);
    setPerms([]);
    setValue("manage_dashboard", false);
    setValue("add_dashboard", false);
  };

  const handleAccordionToggle = (countryId, countryCode) => {
    fetchYearQuarter(countryCode);
    setTimeout(() => {
      setExpandedStates((prevState) => ({
        ...prevState,
        [countryId]: !prevState[countryId],
      }));
    }, 250)
  };

  const allArraysHaveEnabled = (multipleArrays) => {
    return multipleArrays.every(array =>
        array.some(obj => obj.is_enable === true)
    );
  };

  const getSelectedPermissions = (countryCode) => {
    return permissions
      .filter((permission) => isCheckedPerm(countryCode, permission.name))
      .map((permission) => permission.name);
  };

  const hasPermittedOperator = (permissions) => {
    const checkPermissions = (permissionsList) => {
      let isValid = true; // Assume valid unless proven otherwise
  
      for (const permission of permissionsList) {
  
        if (permission.is_enable) {
          if (permission.is_operators) {
            // Check if at least one operator is permitted
            if (
              !permission.operators ||
              !permission.operators.some((operator) => operator.is_permitted)
            ) {
              console.log("Invalid operator permission:", permission);
              isValid = false; // Invalid if no permitted operator found
            }
          }
        }
  
        // Always process sub-permissions recursively
        if (Array.isArray(permission.sub_permissions)) {
          const subPermissionResult = checkPermissions(permission.sub_permissions);
          if (!subPermissionResult) {
            isValid = false; // Propagate invalid status
          }
        }
      }
  
      return isValid;
    };
  
    // Start the recursive check
    return checkPermissions(permissions);
  };

  const compareYears = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if(keys1.length === 0) {
      return true;
    }

    // Check if the number of keys is the same
    if (keys1.length !== keys2.length) {
        return true;
    }

    // Check if the keys have the same length of values
    for (const key of keys1) {
        if (!(key in obj2) || obj1[key].length !== obj2[key].length) {
            return true;
        }
    }

    return false;
  }
  
  const submitUserInformation = (e) => {
    const request = {
      countries: selectedCountryPerm,
      users: selectedUsers,
      group_name: nameGroup,
      web_map_access: e.web_map_access,
      web_portal_access: e.web_portal_access,
      dashboard_access: e.dashboard_access,
      data_permissions: perms,
      add_dashboard: e.add_dashboard,
      manage_dashboard: e.manage_dashboard
    };
  
    // Validation Checks
    const allHaveOperators = selectedCountryPerm.every((item) => hasPermittedOperator(item.permissions));
    const permValidation = allArraysHaveEnabled(selectedCountryPerm?.map((c) => c.permissions));
    const isAlphanumeric = /^[a-zA-Z0-9\s]+$/.test(nameGroup);
    const allHaveYears = selectedCountryPerm.every((c) => {
      const matchingQuarter = quarter?.find((q) => q.countryCode === c.country);
      return (
        compareYears(c?.years || {}, matchingQuarter?.data || {})
      );
    });   

    // Error Handling
    if (!request.group_name) {
      toast.error("Group Name is required", { theme: "colored" });
      return;
    }

    if (!isAlphanumeric) {
      setErrMsgName("Invalid user group name, please provide a valid name with only alphabet letters and numbers.");
      return;
    }

    if (!e.web_map_access && !e.web_portal_access) {
      setErrMsg("Either Data Extract or Web Map should be enabled");
      return;
    }
  
    if (web_map_access === true && request.countries.length === 0) {
      toast.error("Please select at least one country", { theme: "colored" });
      return;
    }
  
    if (web_map_access === true && !permValidation) {
      toast.error("Please select at least one permission for each country", { theme: "colored" });
      return;
    }
  
    if (web_map_access === true && !allHaveOperators) {
      toast.error("Please select at least one operator for relevant sections", { theme: "colored" });
      return;
    }

    if (!allHaveYears) {
      toast.error("Please select at least one year!", { theme: "colored" });
      return;
    }
  
    // Submit Request
    edit ? popConfirmation(request) : createUserGroup(request);
  }; 
  
  const popConfirmation = (request) => {
    setOpenConfirmation(true);
    setEditRequest(request)
  };

  const handleSelectYear = (countryCode, year, checked) => {
    setSelectedCountryPerm((prevState) => {
      return prevState.map((country) => {
        if (country.country === countryCode) {
          if (checked) {
            const { [year]: _, ...remainingYears } = country.years;
            return {
              ...country,
              years: remainingYears
            };
          } else {
            return {
              ...country,
              years: {
                ...country.years,
                [year]: quarter?.find((q) => q.countryCode === countryCode)?.data[year] || []
              }
            };
          }
        }
        return country;
      });
    });
  }; 

  const checkYearSelection = (countryCode, year) => {
    const selectedCountry = selectedCountryPerm?.find((country) => country.country === countryCode);
    if (!selectedCountry) return false;
    const allSelected = selectedCountry.years?.[year]?.length  === quarter?.find((q) => q.countryCode === countryCode)?.data[year]?.length
    return (!allSelected) || false;
  };

  const handleQuarterSelection = (countryCode, year, quarter, checked) => {
    setSelectedCountryPerm((prevState) => {
      return prevState.map((country) => {
        if (country.country === countryCode) {
          const updatedYears = { ...country.years };
  
          if (checked) {
            const filteredQuarters = (updatedYears[year] || []).filter((q) => q !== quarter);
            if (filteredQuarters.length === 0) {
              delete updatedYears[year]; // Remove the year key if no quarters remain
            } else {
              updatedYears[year] = filteredQuarters;
            }
          } else {
            updatedYears[year] = [...(updatedYears[year] || []), quarter];
          }
  
          return {
            ...country,
            years: updatedYears,
          };
        }
        return country;
      });
    });
  };
  

  const checkQuarterSelection = (countryCode, year, quarter) => {
    const selectedCountry = selectedCountryPerm?.find((country) => country.country === countryCode);
    if (!selectedCountry) return false;

    return !selectedCountry.years?.[year]?.includes(quarter) || false;
  };

  const getYears = (data) => {
    if (data) {
      const mappedData = Object.keys(data);
      return mappedData;
    } else {
      console.log("No data found for the given country code.");
    }
  }

  const getQuarters = (data, year) => {
    return data[year] || [];
  }

  const assignPerms = (e) => {
    const available = perms?.includes(e);
    if (available) {
      toast.error("Permission is already assigned", { theme: "colored" });
      setPerm("init");
      return;
    }
    setPerms([...perms, e]);
    setPerm("init");
    setValue("data_perms", [...perms, e]);
  };

  const handleDeletePerms = (e) => {
    const updatedPerms = perms.filter(item => item !== e);
    setPerms(updatedPerms);
    setValue("data_perms", updatedPerms);
  };

  return (
    <>
      <DialogWrapper
        title={"Confirm Edit"}
        cancelLabel="Cancel"
        actionLabel={"Save"}
        actionRed
        small
        open={openConfirmation}
        acceptButton={() => {
          editUserGroup(editReuest);
        }}
        cancelAction={() => {
          setOpenConfirmation(false);
        }}
        onClose={() => {
          setOpenConfirmation(false);
        }}
      >
        <ConfrimTextWrapper>
          {`Are you sure that you want to save the changes done in the user group?`}
        </ConfrimTextWrapper>
      </DialogWrapper>
      <DialogWrapper
        title={edit ? "Edit User Group" : "Add New User Group"}
        cancelLabel="Cancel"
        actionLabel={"Save and Add"}
        open={open}
        setOpenModal={setOpen}
        acceptButton={() => {
          handleSubmit(submitUserInformation)();
        }}
        cancelAction={cancelAction}
        onClose={() => {
          cancelAction();
        }}
      >
        <Grid container spacing={3} justifyContent={"flex-start"}>
          <Grid item xs={5}>
            <InputWrapper>
              <StyledTextField
                id="group_name"
                label="User Group Name"
                placeholder="Input Group Name"
                inputProps={{ ...register("name"), maxLength: 50 }}
              />
            </InputWrapper>
            {errMsgName != null && (
              <Grid item xs={12} style={{ marginLeft: "16px", marginTop: "5px" }}>
                <FormHelperText error>{errMsgName}</FormHelperText>
              </Grid>
            )}
          </Grid>
          <Grid item xs={7}></Grid>
          <Grid item xs={4} style={{ paddingRight: "16px" }}>
              <Grid
                container
                direction="row"
                style={{
                  display: "flex",
                  border: "1px dashed #E4E4E4",
                  marginLeft: "10px",
                  marginTop: "16px",
                }}
              >
                <Grid container item xs={2} justifyContent={"left"}>
                  <div style={{ padding: "0px 8px" }}>
                    <BiWindowAlt
                      style={{
                        width: "22px",
                        height: "22px",
                        color: "#707070",
                        marginTop: "8px",
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      textAlign: "left",
                      color: "#707070",
                      textTransform: "capitalize",
                      marginTop: "8px",
                    }}
                  >
                    Data Extract
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={6}
                  justifyContent="right"
                  style={{ paddingRight: "8px" }}
                >
                  <StyledSwitchField
                    name="web_portal_access"
                    controller={control}
                    register={register}
                  />
                </Grid>
              </Grid>
          </Grid>
          <Grid item xs={4} style={{ paddingRight: "16px" }}>
              <Grid
                container
                direction="row"
                style={{
                  display: "flex",
                  border: "1px dashed #E4E4E4",
                  marginLeft: "10px",
                  marginTop: "16px",
                }}
              >
                <Grid container item xs={2} justifyContent={"left"}>
                  <div style={{ padding: "0px 8px" }}>
                    <IoEarth
                      style={{
                        width: "22px",
                        height: "22px",
                        color: "#707070",
                        marginTop: "8px",
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      textAlign: "left",
                      color: "#707070",
                      textTransform: "capitalize",
                      marginTop: "8px",
                    }}
                  >
                    Web Map
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={6}
                  justifyContent="right"
                  style={{ paddingRight: "8px" }}
                >
                  <StyledSwitchField
                    name="web_map_access"
                    controller={control}
                    register={register}
                  />
                </Grid>
              </Grid>
          </Grid>
          <Grid item xs={4} style={{ paddingRight: "16px", paddingBottom: dashboardPerm ? "16px" : "0px" }}>
            <Grid
              container
              direction="row"
              style={{
                display: "flex",
                border: "1px dashed #E4E4E4",
                marginLeft: "10px",
                marginTop: "16px",
              }}
            >
              <Grid container item xs={2} justifyContent={"left"}>
                <div style={{ padding: "0px 8px" }}>
                  <img
                    style={{
                      marginTop: "8px",
                    }}
                    src="/assets/dashboard.png"
                    alt="dashboardlogo"
                  />
                </div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    textAlign: "left",
                    color: "#707070",
                    textTransform: "capitalize",
                    marginTop: "8px",
                  }}
                >
                  Dashboard
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                justifyContent="right"
                style={{ paddingRight: "8px" }}
              >
                <StyledSwitchField
                  name="dashboard_access"
                  controller={control}
                  register={register}
                />
              </Grid>
            </Grid>
          </Grid>
          {errMsg != null && (
            <Grid item xs={12} style={{ marginLeft: "16px", marginTop: "5px", paddingTop: "0px" }}>
              <FormHelperText error>{errMsg}</FormHelperText>
            </Grid>
          )}
           {dashboardPerm && (
          <>
            <Grid item xs={4}>
              <InputWrapper>
                <StyledSelect
                  label={"Permitted Dashboards"}
                  defaultVal={"Select"}
                  options={dataPermissions}
                  control={perm}
                  setControl={assignPerms}
                />
              </InputWrapper>
            </Grid>
            <Grid item xs={6} display={"flex"} flexDirection={"row"}>
              <StyledFormControlCheckBoxLabel
                control={
                  <Checkbox
                    checked={add_dashboard}
                    onChange={(e) =>
                      setValue("add_dashboard", e.target.checked)
                    }
                    size="large"
                  />
                }
                label={"Add New Dashboard"}
                sx={{
                  paddingTop: "23px"
                }}
              />
              <StyledFormControlCheckBoxLabel
                control={
                  <Checkbox
                    checked={manage_dashboard}
                    onChange={(e) =>
                      setValue("manage_dashboard", e.target.checked)
                    }
                    size="large"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        strokeWidth: 1, // Adjust border width
                      }
                    }}
                  />
                }
                label={"Manage Dashboard"}
                sx={{
                  paddingTop: "23px"
                }}
              />
            </Grid>
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={4} style={{paddingTop: "0px", paddingLeft: "25px"}}>
              <MultiSelectChip models={perms} handleDelete={handleDeletePerms}/>
            </Grid>
            <Grid item xs={8}>
            </Grid>
          </>
          )}
          { web_map_access && selectedCountries?.length > 0 && (
            <Grid item xs={12}>
              <TextWrapper>Assign Permissions</TextWrapper>
            </Grid>
          )}
          {web_map_access && selectedCountries.map((country) => (
            <Grid item xs={12}>
              <AccordianWrapper>
                <Accordion 
                  key={country._id} 
                  expanded={!!expandedStates[country._id]}
                  onChange={() => handleAccordionToggle(country._id, country.code)}
                >
                  <AccordionSummary>
                    <AccordionHeader>
                      <InnerAccordionHeader>
                        <StyledIconButton onClick={() => onRemoveCountry(country._id, country.code)}>
                          <Radio
                            checked={true}
                            size="small"
                          />
                        </StyledIconButton>
                        {country.label}
                        <PermissionsWrapper>{getSelectedPermissions(country.code).join(", ") || ""}</PermissionsWrapper>
                      </InnerAccordionHeader>
                      <StyledSelectAll
                        onClick={(event) => {
                          handleSelectAll(country.code);
                          event.stopPropagation();
                        }}
                      >
                        Select All
                      </StyledSelectAll>
                      <StyledIconButton onClick={() => onRemoveCountry(country._id, country.code)}>
                        <Close fontSize="small"/>
                      </StyledIconButton>
                    </AccordionHeader>
                  </AccordionSummary>
                  <AccordionDetails>
                    {getYears(quarter?.find((q) => q.countryCode === country.code)?.data)?.map((year) => {
                      return (
                        <div style={{ borderBottom: "1px solid #EEEEEE", paddingLeft: "70px" }}>
                          <StyledFormControlLabel
                            control={
                              <Checkbox
                                checked={checkYearSelection(country.code, year)}
                                onChange={(e) =>
                                  handleSelectYear(country.code, year, e.target.checked)
                                }
                                size="small"
                              />
                            }
                            label={`Year ${year}`}
                          />
                          <div style={{display: "flex", flexDirection: "row"}}>
                            {getQuarters(quarter?.find((q) => q.countryCode === country.code)?.data, year).map((q) => {
                              return (
                                  <StyledFormControlLabel
                                    control={
                                      <Checkbox
                                        checked={checkQuarterSelection(country.code, year, q)}
                                        onChange={(e) =>
                                          handleQuarterSelection(country.code, year, q, e.target.checked)
                                        }
                                        disabled={!checkYearSelection(country.code, year)}
                                        size="small"
                                      />
                                    }
                                    label={q}
                                    style={{paddingLeft: "30px"}}
                                  />
                              )
                            })}
                          </div>
                        </div>
                      )
                    })}
                    {permissions.map((permission) => (
                      <div key={permission.id}>
                        <div style={{ borderBottom: "1px solid #EEEEEE", paddingLeft: "70px" }}>
                          <StyledFormControlLabel
                            control={
                              <Checkbox
                                checked={isCheckedPerm(country.code, permission.name)}
                                onChange={(e) =>
                                  handleAddPermissions(country.code, permission.name, e.target.checked, permission?.is_operators, permission?.is_mno)
                                }
                                size="small"
                              />
                            }
                            label={permission.name}
                          />
                        </div>
                        { permission.is_operators && getOperators({
                          code: country.code, 
                          perm: permission.name,
                          is_mno: permission.is_mno 
                        })}
                        
                        {/* Render Sub-Permissions */}
                        {permission.sub_permissions && permission.sub_permissions.length > 0 && (
                          <div>
                            {permission.sub_permissions.map((subPermission) => (
                              <div>
                                <Box sx={{ display: 'flex', flexDirection: 'column', borderBottom: "1px solid #EEEEEE", paddingLeft: "100px" }}>
                                  <StyledFormControlLabel
                                    label={subPermission.name}
                                    control={
                                      <Checkbox
                                      checked={isChecked(country.code, permission.name, subPermission.name)}
                                      disabled={checkDisable(country.code, permission.name)}
                                      onChange={(e) => 
                                        handleAddSubPermissions(
                                          country.code, permission.name, subPermission.name, e.target.checked, subPermission.is_operators, subPermission.is_mno
                                        )}
                                      size="small"
                                      />
                                    }
                                  />
                                </Box>
                                {subPermission.is_operators && getOperators({
                                  code: country.code, 
                                  perm: permission.name, 
                                  subPerm: subPermission.name, 
                                  is_mno: subPermission.is_mno
                                })}
                                
                                {/* Render Sub-Sub-Permissions (nested further if any) */}
                                {subPermission.sub_permissions && subPermission.sub_permissions.length > 0 && (
                                  <div>
                                    {subPermission.sub_permissions.map((subSubPermission) => (
                                      <div>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', borderBottom: "1px solid #EEEEEE", paddingLeft: "130px"}}>
                                          <StyledFormControlLabel
                                            control={
                                              <Checkbox
                                                checked={isCheckedSubPerm(country.code, permission.name, subPermission.name, subSubPermission.name)}
                                                onChange={(e) =>
                                                  handleAddNestedSubPermissions(
                                                    country.code, permission.name, subPermission.name, subSubPermission.name, e.target.checked, subSubPermission.is_operators, subSubPermission.is_mno
                                                  )
                                                }
                                                disabled={checkDisableSubPerm(country.code, permission.name, subPermission.name)}
                                                size="small"
                                              />
                                            }
                                            label={subSubPermission.name}
                                          />
                                        </Box> 
                                        {subSubPermission.is_operators && getOperators({
                                          code: country.code, 
                                          perm: permission.name, 
                                          subPerm: subPermission.name, 
                                          subSubPerm: subSubPermission.name
                                        })}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </AccordianWrapper>
            </Grid>
          ))}
          {(countries.length > 0 && viewCountries && web_map_access === true) &&(
            <Grid item xs={12}>
              <CountryWrapper>
                <Accordion key={2} defaultExpanded>
                  <AccordionSummary>
                  <AccordionHeader>
                    <InnerAccordionHeader>Select a Country</InnerAccordionHeader>
                    <IconButton onClick={() => setViewCountries(false)} size="small">
                      <Close fontSize="small"/>
                    </IconButton>
                  </AccordionHeader>
                  </AccordionSummary>
                  <AccordionDetails>
                    {countries.map((country) => (
                      <div key={country.id} style={{paddingLeft: "40px"}}>
                        <StyledFormControlLabel
                          control={
                            <Radio
                              checked={selectedCountries.includes(country._id)}
                              onChange={() => onSelectCountry(country._id)}
                              size="small"
                            />
                          }
                          label={country.label}
                        />
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </CountryWrapper>
            </Grid>
          )}
          {!viewCountries && web_map_access === true && (
            <>
              <Grid item xs={4}>
                <ButtonWrapper>
                  <StyledButton
                    variant={"outlined"}
                    iconLeft={<MdLibraryAdd size={20} />}
                    onClick={() => {
                      setViewCountries(true);
                    }}
                  >
                    {selectedCountries.length > 0 ? `Add Another Country` : `Add Countries`}
                  </StyledButton>
                </ButtonWrapper>
              </Grid>
              <Grid xs={8}></Grid>
            </>
          )}
          <Grid item xs={5}>
            <InputWrapper>
            <TypeSelect
              placeholder={"Select Users"}
              options={users?.map(user => user.email).sort((a, b) => a.localeCompare(b))}
              control={email}
              setControl={handleUserSelection}
              usergroup={true}
              setInputControl={(value) => setEmail(value)}
            />
            </InputWrapper>
          </Grid>
          <Grid item xs={7}></Grid>
          {selectedUsers.length > 0 && (
            <Grid item xs={12}>
              <AccordianWrapper>
                <StyledTable
                  headCells={userGroupUserHeadCells}
                  rows={[...selectedUsers].sort((a, b) => a.name.localeCompare(b.name))}
                  deleteEnabaled={true}
                  action
                  deleteClick={handleRemoveUser}
                  isEdit={false}
                />
              </AccordianWrapper>
            </Grid>          
          )}
        </Grid>
      </DialogWrapper>
    </>
  );
};

export default UserGroupModal;
